export enum PressReleaseStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  Featured = 4,
  Promoted = 5,
  Banned = 6,
  NotActive = 7
}
